export enum DebugKey {
  /** Logged to Sentry - Do not use for sensitive data */
  Auth = 'stars:auth',
  Bridge = 'stars:bridge',
  C2L = 'stars:c2l',
  Embedded = 'stars:embedded',
  Error = 'stars:error',
  Frame = 'stars:frame',
  GeoComply = 'stars:geoComply',
  MockServer = 'mock:server',
  Monitor = 'stars:monitor',
  Overrides = 'stars:overrides',
  Request = 'stars:request',
  RequestInfo = 'stars:request:info',
  RgError = 'rgError:sePT',
  SdkRequest = 'sdk:request',
  SdkSocket = 'sdk:socket',
  Socket = 'stars:socket',
  VaderArgs = 'vader:args',
  VaderCallback = 'vader:callback',
  VaderManifest = 'vader:manifest',
  VaderOneTrust = 'vader:one-trust',
  VaderPage = 'vader:page',
  VaderPreview = 'vader:preview',
  VaderServer = 'vader:server',
  VaderState = 'vader:state',
  VaderWebsite = 'vader:website',
  VaderWidget = 'vader:widget',
  Wizard = 'stars:wizard'
}
